import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { LottoSaleDialog } from '../../../components/lottery/LottoSaleDialog';
import { PayoutDialog } from '../../../components/lottery/PayoutDialog';
import CaseSimulatorMainSection from './CaseSimulatorMainSection';
import { useCaseSimulatorPageLogic } from '../hooks/useCaseSimulatorPageLogic';

type CaseSimulatorContentProps = {
    downloadActionContainer?: HTMLElement | null;
    storeId?: string;
};

const CaseSimulatorContent: React.FC<CaseSimulatorContentProps> = ({ downloadActionContainer, storeId }) => {
    const { actions, dialogs, state } = useCaseSimulatorPageLogic(storeId);

    if (state.packsLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                <CircularProgress size={60} />
            </Box>
        );
    }

    return (
        <>
            {state.packsError && (
                <Box sx={{ p: 2 }}>
                    <Alert severity="error" sx={{ mb: 0 }} onClose={actions.dismissError}>
                        {state.packsError}
                    </Alert>
                </Box>
            )}

            <CaseSimulatorMainSection
                createPackLoading={state.createPackLoading}
                locations={state.locations}
                games={state.games}
                gamesLoading={state.gamesLoading}
                hasStoreId={state.hasStoreId}
                lotteryPayoutLoading={state.lotteryPayoutLoading}
                lottoSaleLoading={state.lottoSaleLoading}
                onCreatePack={actions.handleCreatePack}
                onGameChange={actions.handleGameChange}
                onLocationChange={actions.handleLocationChange}
                onLotteryPayout={actions.onLotteryPayout}
                onLottoSale={actions.handleLottoSale}
                onPackReturn={actions.handlePackReturn}
                processedPacks={state.processedPacks}
                scannerConfig={state.scannerConfig}
                scratcherPayoutLoading={state.scratcherPayoutLoading}
                selectedGame={state.selectedGame}
                selectedLocationId={state.selectedLocationId}
                storeId={state.selectedStoreId}
                totalPacks={state.totalPacks}
                downloadActionContainer={downloadActionContainer}
            />

            <PayoutDialog
                open={dialogs.payoutDialogOpen}
                payoutType={dialogs.selectedPayoutType}
                selectedPack={dialogs.selectedPayoutPack}
                payoutAmount={dialogs.payoutAmount}
                posAmount={dialogs.posAmount}
                loading={dialogs.selectedPayoutType === 'lotto' ? state.lotteryPayoutLoading : state.scratcherPayoutLoading}
                onPayoutAmountChange={dialogs.setPayoutAmount}
                onPosAmountChange={dialogs.setPosAmount}
                onSubmit={actions.handlePayoutSubmit}
                onCancel={actions.handlePayoutCancel}
            />

            <LottoSaleDialog
                open={dialogs.lottoSaleDialogOpen}
                amount={dialogs.lottoSaleAmount}
                loading={state.lottoSaleLoading}
                onAmountChange={dialogs.setLottoSaleAmount}
                onSubmit={actions.handleLottoSaleSubmit}
                onCancel={actions.handleLottoSaleCancel}
            />
        </>
    );
};

export default React.memo(CaseSimulatorContent);
